/*
 * @Description: 常见的工具类集合
 * @Author: kadenwang@tencent.com
 * @Date: 2021-11-19 16:03:48
 * @LastEditors: kadenwang@tencent.com
 * @LastEditTime: 2022-05-07 16:45:26
 */
export var getLoginCgiHost = function () { return (location.host.includes('qq.com') ? '//yybadaccess.sparta.html5.qq.com' : '//unifiedaccess.gameloop.com'); };
export var isAppMarket = function () { return window.navigator.userAgent.includes('Tencent AppMarket') || window.navigator.userAgent.includes('GAMELOOP'); };
// 后台也要配置
export var getRedirectUrl = function (nocache) {
    if (nocache === void 0) { nocache = false; }
    return (location.host.includes('qq.com') ? 'https://halodev.sparta.html5.qq.com/syzs/syzsweb/UIFramework/index.html' : "https://webapp.gameloop.com/syzs/syzsweb/UIFramework/index.html".concat(nocache ? "?_t=".concat(Math.random()) : ''));
};
export var getMailCgiHost = function () { return (location.host.includes('qq.com') ? '//yybadaccess.sparta.html5.qq.com' : '//ualbusiness.gameloop.com'); };
//# sourceMappingURL=util.js.map